// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yAre","content":"styles_content__3ghs-","tableWrap":"styles_tableWrap__1WtZ-"};